module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-container"
  }, [_c('main-toolbar', {
    attrs: {
      "mode": "projects"
    }
  }), _vm._v(" "), (_vm.projectId) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticClass: "projects-feature-image__img",
    attrs: {
      "src": _vm.featureImage
    }
  })])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 18,
      "lg": 12
    }
  }, [_c('el-card', {
    staticClass: "projects-documentation__card",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-567b9f5d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-documentations/project-documentations.vue
// module id = 290
// module chunks = 0